export default "__VITE_ASSET__7fef35f5__"